// extracted by mini-css-extract-plugin
export default {"disabledFormOverlay":"Yymz4e"};